import axios from 'axios';
import { logsApiConfig } from '../../shared/config/logs-api.config';

const logApi = axios.create({ baseURL: logsApiConfig.host });

export const sendLog = ({ data, headers = { 'Content-Type': 'application/json' } }) => {
  try {
    logApi.post(logsApiConfig.URIS.logAggregator, data, { headers });
  } catch (error) {
    console.error('Error sending log to API', error);
  }
};
